import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

import { base_url2 } from 'env';
import { getToken } from 'store/common/common';

let echoInstance = null;

const parsePort = (value, fallback) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
};

const resolveScheme = () => {
  const scheme = process.env.REACT_APP_REVERB_SCHEME;
  if (scheme) {
    return scheme.toLowerCase();
  }
  return window.location.protocol === 'https:' ? 'https' : 'http';
};

const buildAuthEndpoint = () => {
  if (process.env.REACT_APP_REVERB_AUTH_ENDPOINT) {
    return process.env.REACT_APP_REVERB_AUTH_ENDPOINT;
  }

  if (base_url2) {
    return `${base_url2}/broadcasting/auth`;
  }

  return '/broadcasting/auth';
};

const getAppKey = () => process.env.REACT_APP_REVERB_APP_KEY;

const baseConfig = (token) => {
  const scheme = resolveScheme();
  const authEndpoint = buildAuthEndpoint();

  return {
    broadcaster: 'reverb',
    key: getAppKey(),
    wsHost: process.env.REACT_APP_REVERB_HOST || window.location.hostname,
    wsPort: parsePort(process.env.REACT_APP_REVERB_PORT, 8080),
    wssPort: parsePort(process.env.REACT_APP_REVERB_PORT, 8080),
    forceTLS: scheme === 'https',
    enabledTransports: ['ws', 'wss'],
    authEndpoint,
    authTransport: 'ajax',
    auth: token
      ? {
          withCredentials: true,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      : undefined,
  };
};

export const createEchoClient = (overrides = {}) => {
  const token = getToken();
  const appKey = getAppKey();

  if (!token) {
    return null;
  }

  if (!appKey && !overrides.key) {
    console.warn(
      'Realtime notifications are disabled because REACT_APP_REVERB_APP_KEY is missing.',
    );
    return null;
  }

  window.Pusher = Pusher;

  const config = {
    ...baseConfig(token),
    ...overrides,
  };

  const instance = new Echo(config);

  return instance;
};

export const getEchoClient = (overrides) => {
  if (!echoInstance) {
    echoInstance = createEchoClient(overrides);
  }

  return echoInstance;
};

export const resetEchoClient = () => {
  if (echoInstance) {
    echoInstance.disconnect();
    echoInstance = null;
  }
};
